/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';

export default (state = {error: false, isFetching: false, items: {}}, action) => {
    switch (action.type) {
        case types.REQUEST_POST:
            return {
                ...state,
                error: false,
                isFetching: true,
            };
        case types.RECEIVE_POST:
            return {
                ...state,
                error: false,
                isFetching: false,
                items: {...state.items, [action.post.id]: action.post},
            };
        case types.ERROR_POST:
            return {
                ...state,
                error: true,
                isFetching: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/post.js